import { ChangeDetectionStrategy, Component, computed, inject, input, model, OnInit, output } from '@angular/core';
import { GetProductsRequestPost, Product, ProductsUtils } from '../../common';
import { ProductsService } from '../../services';

@Component({
    selector: 'ca-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProductsService],
    standalone: false
})
export class ProductCardComponent implements OnInit {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    public product = model<Product>();
    public productId = model<string>();
    public noProductText = input<string>('PRODUCT_CARD.NO_PRODUCT');
    public showAllProductsButtonText = input<string>('PRODUCT_PICKER.BUTTON.SHOW_ALL');
    public productPickerHeaderText = input<string>('PRODUCT_PICKER.TITLE');
    public languageCode = input.required<GetProductsRequestPost['languageCode']>();
    public countryCode = input.required<GetProductsRequestPost['countryCode']>();
    public productType = input<Product['productType']>();
    public allowedProductTypes = input<Product['productType'][]>();
    public allowDifferentProductTypeSelection = input<boolean>(true);
    public singleProduct = computed(() => this.productsService.products()?.[0]);
    public productRemoved = output<Product>();
    public productSelected = output<Product>();
    public productsService = inject(ProductsService);

    ngOnInit(): void {
        this.readProduct();
    }

    onProductSelected(products: Product[]): void {
        const product = products?.[0];
        this.product.set(product);
        this.productSelected.emit(product);
    }

    onProductRemoved(): void {
        const product = this.product() || this.singleProduct();
        if (product) {
            this.productRemoved.emit(product);
        }
        this.product.set(undefined);
        this.productId.set(undefined);
        this.productsService.products.set([]);
    }

    readProduct(): void {
        const productId = this.productId();
        if (!productId) {
            return;
        }

        this.productsService.readProducts({
            languageCode: this.languageCode(),
            countryCode: this.countryCode(),
            pageSize: 1,
            pageIndex: 0,
            productIDs: [productId]
        });
    }
}
